import * as Sentry from "@sentry/vue";

export default defineNuxtPlugin((nuxtApp) => {
  const { public: { sentry } } = useRuntimeConfig();

  // The public share page carries its token in the URL, which errors and replays would record
  if (!sentry.dsn || process.env.BASE_URL || (import.meta.client && window.location.pathname.startsWith("/share/"))) {
    return;
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: sentry.dsn,
    environment: sentry.environment,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],

    // Configure this whole part as you need it!
    tracesSampleRate: 1.0, // Change in prod

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", "https://app.tickable.nl"],

    replaysSessionSampleRate: 0.1, // Change in prod
    replaysOnErrorSampleRate: 1.0, // Change in prod if necessary
  });

  // Replay is the biggest part of Sentry, so it loads from Sentry's CDN (same version as the SDK)
  // after the first render; errors are reported from init above either way. A dynamic
  // import("@sentry/vue") would not split it off: that module is already in the entry chunk.
  nuxtApp.hook("app:mounted", async () => {
    try {
      const replayIntegration = await Sentry.lazyLoadIntegration("replayIntegration");
      Sentry.addIntegration(replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }));
    } catch {
      // Blocked or offline: no replay, error reporting carries on.
    }
  });
});
